var map = {
	"./backend/iconfont/iconfont.js": [
		"4254",
		"chunk-2d0c0693"
	],
	"./client/iconfont/iconfont.js": [
		"1e24",
		"chunk-2d0b688c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1af7";
module.exports = webpackAsyncContext;